<template>
  <global-app> </global-app>
</template>

<script>
import _ from "lodash";

import moduleSurat from "@/store/surat/moduleSurat.js";

// query
import { GET_COUNT, pagination } from "@/query/surat";
import { filters } from "@/query/surat";

export default {
  data() {
    return {
      surat: []
    };
  },
  computed: {
    navigations() {
      return {
        action: {
          buttonTitle: "Buat Surat",
          to: "/surat/buat"
        },
        active: this.$route.params.filter || "masuk",
        list: [
          {
            icon: "CheckSquareIcon",
            text: "Disposisi",
            active: "disposisi",
            showMobile: "left",
            to: "/surat/disposisi",
            badge: 0,
            badgeColor: "danger",
            gql: filters.DISPOSISI(this.$user.id)
          },

          {
            icon: "FileIcon",
            text: "Konsep",
            active: "konsep",
            showMobile: false,
            to: "/surat/konsep",
            badge: 0,
            gql: filters.KONSEP(this.$user.id)
          },

          {
            icon: "InboxIcon",
            text: "Masuk",
            active: "masuk",
            showMobile: "left",
            to: "/surat/masuk",
            badge: 0,
            gql: filters.SURAT_MASUK()
          },
          {
            icon: "ArrowRightIcon",
            text: "Keluar",
            active: "keluar",
            showMobile: "right",
            to: "/surat/keluar",
            badge: 0,
            gql: filters.SURAT_KELUAR()
          },
          {
            icon: "SendIcon",
            text: "Terkirim",
            active: "terkirim",
            showMobile: false,
            to: "/surat/terkirim",
            badge: 0,
            gql: filters.TERKIRIM(this.$user.id)
          },
          {
            icon: "ArchiveIcon",
            text: "Arsip",
            active: "arsip",
            badge: 0,
            to: "/surat/arsip",
            gql: filters.ARSIP()
          },
          {
            icon: "TrashIcon",
            text: "Sampah",
            active: "sampah",
            badge: 0,
            to: "/surat/sampah",
            gql: filters.SAMPAH(this.$user.id)
          }
        ]
      };
    }
  },
  apollo: {
    countKonsep: {
      query() {
        return GET_COUNT;
      },
      update: data => data.surat.paginatorInfo.total,
      variables() {
        return this.countVariables("konsep");
      },
      error() {
        this.error = true;
      },
      fetchPolicy: "cache-and-network"
    },
    countDisposisi: {
      query() {
        return GET_COUNT;
      },
      update: data => data.surat.paginatorInfo.total,
      variables() {
        return this.countVariables("disposisi");
      },
      error() {
        this.error = true;
      },
      fetchPolicy: "cache-and-network"
    }
  },
  watch: {
    "$store.state.globalApp.navigations.refetchBadge"() {
      this.refetchBadge();
    },
    countKonsep() {
      this.updateBadge();
    },
    countDisposisi() {
      this.updateBadge();
    }
  },
  async created() {
    if (!this.$store.hasModule("surat"))
      await this.$store.registerModule("surat", moduleSurat);
    await this.$store.dispatch("globalApp/setNavigations", this.navigations);
    this.pollingBadge();
  },
  methods: {
    pollingBadge(interval = 180000) {
      this.$apollo.queries.countKonsep.startPolling(interval);
      this.$apollo.queries.countDisposisi.startPolling(interval);
    },
    getCurrentNavigation(page = this.$route.params.filter) {
      const currentNavigation = this.navigations.list.find(
        navigation => navigation.active === page
      );

      return currentNavigation;
    },
    countVariables(page) {
      const { orderBy, where } = this.getCurrentNavigation(page).gql;
      return {
        perPage: pagination.perPage,
        page: this.paginationPage,
        orderBy,
        where: where
      };
    },
    refetchBadge() {
      if (this.$store.state.globalApp.navigations.refetchBadge) {
        this.$apollo.queries.countKonsep.refetch();
        this.$apollo.queries.countDisposisi.refetch();
        this.$store.dispatch("globalApp/refetchBadge", false);
      }
    },
    async updateBadge() {
      this.$nextTick().then(async () => {
        const navigationsList = _.cloneDeep(this.navigations.list);

        let list = navigationsList.map(data => {
          if (data.active == "konsep") {
            data.badge = this.countKonsep;
          }
          if (data.active == "disposisi") {
            data.badge = this.countDisposisi;
          }
          return data;
        });

        const navigations = { ...this.navigations, list: [...list] };
        await this.$store.dispatch("globalApp/setNavigations", navigations);
      });
    }
  }
};
</script>
